var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"headline"},[_vm._m(0),_c('div',{staticClass:"container"},[_c('div',{staticClass:"headline-lg"},[_vm._v(_vm._s(_vm.title))])]),_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border-img"},[_c('img',{attrs:{"src":require("@/assets/img/img_sectionheader_topbar.png")}})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border-img"},[_c('img',{attrs:{"src":require("@/assets/img/img_sectionheader_bottombar.png")}})])
}]

export { render, staticRenderFns }